import axios from "../../axios-config";

export const PROFESSORU_ACTIVITY_TYPES = {
  LESSON_COMPLETED: "complete_lesson",
  GUIDE_READ: "read_guide",
  TALK_WATCHED: "watch_talk",
  TOUR_COMPLETED: "complete_tour",
  QUESTION_POSTED: "post_question",
  REPLY_ADDED: "add_reply",
};

export const PROFESSORU_MILESTONE_ACTIVITY_TYPES = {
  COMPLETE_FIRST_LESSON: "complete_first_lesson",
  COMPLETE_THREE_LESSONS: "complete_three_lessons",
  COMPLETE_FIVE_LESSONS: "complete_five_lessons",
  COMPLETE_ALL_LESSONS: "complete_all_lessons",
  COMPLETE_TEN_TALKS: "complete_ten_talks",
  COMPLETE_TEN_GUIDES: "complete_ten_guides",
  POST_A_QUESTION_AND_REPLY: "post_a_question_and_reply",
  BOOK_YOUR_SESSION: "book_your_session",
};

/**
 * Track a single ProfessorU activity event.
 * The backend should aggregate these events into milestone progress and
 * return any newly reached milestones in `milestonesReached`.
 *
 * @param {string} activityType - one of PROFESSORU_ACTIVITY_TYPES
 * @param {object} metadata - context such as contentId, moduleId, tourName, etc.
 */
export const trackProfessorUActivity = async (activityType, metadata = {}) => {
  const response = await axios.post("/user/v1/activity/track", {
    activityType,
    metadata,
  });
  return response?.data?.data || { isFirstVisit: false, visitCount: 0, milestonesReached: [] };
};
